import { render, staticRenderFns } from "./CardExpert.vue?vue&type=template&id=f1c28740&scoped=true&"
import script from "./CardExpert.vue?vue&type=script&lang=js&"
export * from "./CardExpert.vue?vue&type=script&lang=js&"
import style0 from "./CardExpert.vue?vue&type=style&index=0&id=f1c28740&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c28740",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VImg})
